// src/redux/slices/documentSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE_URL = process.env.REACT_APP_API_URL ;






// GET all documents with optional filters
export const fetchDocuments = createAsyncThunk(
  'documents/fetchAll',
  async ({ serviceId, description } = {}, thunkAPI) => {
    try {
      let query = [];

      // Use serviceId passed or fallback to localStorage
      const id = serviceId || localStorage.getItem("adminuserId");
      query.push(`serviceId=${id}`);

      if (description) query.push(`description=${encodeURIComponent(description)}`);

      const queryString = query.length ? `?${query.join('&')}` : '';

      const res = await fetch(`${BASE_URL}/documents${queryString}`);
      const data = await res.json();

      return data.documents;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// POST: Add a new document
export const addDocument = createAsyncThunk('documents/add', async (payload, thunkAPI) => {
  try {
    const res = await fetch(`${BASE_URL}/document`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();

     if (!res.ok) {
        return thunkAPI.rejectWithValue(data.message || "Add failed");
      }
    return data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

// PUT: Toggle Assign
export const toggleAssign = createAsyncThunk(
  'documents/toggleAssign',
  async ({ id, serviceId, subServiceId }, thunkAPI) => {
    try {
      const res = await fetch(`${BASE_URL}/documents/${id}/toggle-assign`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ serviceId, subServiceId }),
      });
      if (!res.ok) throw new Error('Toggle assign failed');
      return { id };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// PUT: Toggle Mandate
export const toggleMandate = createAsyncThunk(
  'documents/toggleMandate',
  async ({ id, serviceId, subServiceId }, thunkAPI) => {
    try {
      const res = await fetch(`${BASE_URL}/documents/${id}/toggle-mandate`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ serviceId, subServiceId }),
      });
      if (!res.ok) throw new Error('Toggle mandate failed');
      return { id };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

const documentSlice = createSlice({
  name: 'documents',
  initialState: {
    documents: [],
    loading: false,
    error: null,
  },
  reducers: {
      resetDocuments: (state) => {
      state.documents = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload;
      })
      .addCase(fetchDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add
      .addCase(addDocument.fulfilled, (state, action) => {
        state.documents.push(action.payload);
      })

      // Toggle Assign
      .addCase(toggleAssign.fulfilled, (state, action) => {
        const doc = state.documents.find(d => d.id === action.payload.id);
        if (doc) {
          doc.assigned = doc.assigned ? 0 : 1;
        }
      })

      // Toggle Mandate
      .addCase(toggleMandate.fulfilled, (state, action) => {
        const doc = state.documents.find(d => d.id === action.payload.id);
        if (doc) {
          doc.mandatory = doc.mandatory ? 0 : 1;
        }
      });
  },
});

export const { resetDocuments } = documentSlice.actions;
export default documentSlice.reducer;





// // src/redux/slices/documentSlice.js
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// const BASE_URL = process.env.REACT_APP_API_URL;

// // Helper to support both id / _id
// const findDoc = (docs, id) =>
//   docs.find(d => d.id === id || d._id === id);

// // ✅ FETCH DOCUMENTS (only when called manually)
// export const fetchDocuments = createAsyncThunk(
//   'documents/fetchAll',
//   async ({ serviceId, description } = {}, thunkAPI) => {
//     try {
//       let query = [];

//       const id = serviceId || localStorage.getItem("adminuserId");
//       if (id) query.push(`serviceId=${id}`);
//       if (description) query.push(`description=${encodeURIComponent(description)}`);

//       const queryString = query.length ? `?${query.join('&')}` : '';

//       const res = await fetch(`${BASE_URL}/documents${queryString}`);

//       if (!res.ok) throw new Error("Failed to fetch documents");

//       const data = await res.json();

//       return data.documents || [];
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.message);
//     }
//   }
// );

// // ✅ ADD DOCUMENT
// export const addDocument = createAsyncThunk(
//   'documents/add',
//   async (payload, thunkAPI) => {
//     try {
//       const res = await fetch(`${BASE_URL}/document`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) throw new Error("Add failed");

//       const data = await res.json();
//       return data;
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.message);
//     }
//   }
// );

// // ✅ TOGGLE ASSIGN
// export const toggleAssign = createAsyncThunk(
//   'documents/toggleAssign',
//   async ({ id, serviceId, subServiceId }, thunkAPI) => {
//     try {
//       const res = await fetch(`${BASE_URL}/documents/${id}/toggle-assign`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ serviceId, subServiceId }),
//       });

//       if (!res.ok) throw new Error('Toggle assign failed');

//       return { id };
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.message);
//     }
//   }
// );

// // ✅ TOGGLE MANDATE
// export const toggleMandate = createAsyncThunk(
//   'documents/toggleMandate',
//   async ({ id, serviceId, subServiceId }, thunkAPI) => {
//     try {
//       const res = await fetch(`${BASE_URL}/documents/${id}/toggle-mandate`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ serviceId, subServiceId }),
//       });

//       if (!res.ok) throw new Error('Toggle mandate failed');

//       return { id };
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.message);
//     }
//   }
// );

// const documentSlice = createSlice({
//   name: 'documents',
//   initialState: {
//     documents: [],
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     resetDocuments: (state) => {
//       state.documents = [];
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder

//       // FETCH
//       .addCase(fetchDocuments.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchDocuments.fulfilled, (state, action) => {
//         state.loading = false;
//         state.documents = action.payload;
//       })
//       .addCase(fetchDocuments.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // ADD
//       .addCase(addDocument.fulfilled, (state, action) => {
//         state.documents.push(action.payload);
//       })

//       // TOGGLE ASSIGN (Optimistic UI)
//       .addCase(toggleAssign.fulfilled, (state, action) => {
//         const doc = findDoc(state.documents, action.payload.id);
//         if (doc) doc.assigned = doc.assigned ? 0 : 1;
//       })

//       // TOGGLE MANDATE
//       .addCase(toggleMandate.fulfilled, (state, action) => {
//         const doc = findDoc(state.documents, action.payload.id);
//         if (doc) doc.mandatory = doc.mandatory ? 0 : 1;
//       });
//   },
// });

// export const { resetDocuments } = documentSlice.actions;
// export default documentSlice.reducer;